'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.default = withActions;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDisplayName = require('react-display-name');

var _reactDisplayName2 = _interopRequireDefault(_reactDisplayName);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __DEV__ = process.env.NODE_ENV !== 'production';


function hoistSafeStatics(targetComponent, sourceComponent) {
    var blacklist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return (0, _hoistNonReactStatics2.default)(targetComponent, sourceComponent, (0, _assign2.default)({
        // prevent hoisting the following static methods
        getDispatcherActions: true,
        getDispatchParamToProps: true,
        getDispatchParamsToProps: true,
        appendActionDispatcher: true,
        WrappedComponent: true
    }, blacklist));
}

function withActions(mapParamsToProps) {
    for (var _len = arguments.length, actions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        actions[_key - 1] = arguments[_key];
    }

    if (!(typeof mapParamsToProps === 'undefined' || mapParamsToProps === null)) {
        (0, _invariant2.default)(typeof mapParamsToProps === 'function', '"mapParamsToProps" must be either a function, or null.');
    }

    if (typeof actions !== 'undefined' && actions !== null) {
        actions = Array.isArray(actions) ? actions : [actions];
    }

    (0, _invariant2.default)(actions.length !== 0, '"withActions(null, [action])" requires a minimum of 1 action, pass null as the first parameter if no "mapParamsToProps" function is required.');

    var paramsToProps = mapParamsToProps || function (params) {
        return params;
    };

    if (__DEV__) {
        actions.forEach(function (_ref) {
            var name = _ref.name,
                staticMethod = _ref.staticMethod,
                staticMethodName = _ref.staticMethodName,
                filterParamsToProps = _ref.filterParamsToProps,
                initServerAction = _ref.initServerAction,
                initClientAction = _ref.initClientAction,
                hoc = _ref.hoc;


            (0, _invariant2.default)(typeof name !== 'undefined', 'Action requires a \'name\' property.');
            (0, _invariant2.default)(typeof name === 'string', 'Action expects \'name\' to be a string.');

            if (typeof staticMethod !== 'undefined') {
                (0, _invariant2.default)(typeof staticMethod === 'function', 'Action \'' + name + '\' expects \'staticMethod\' to be a function.');
            } else {
                (0, _invariant2.default)(typeof staticMethodName !== 'undefined', 'Action \'' + name + '\' requires a \'staticMethodName\' property.');
                (0, _invariant2.default)(typeof staticMethodName === 'string', 'Action \'' + name + '\' expects \'staticMethodName\' to be a string.');
            }

            (0, _invariant2.default)(typeof filterParamsToProps !== 'undefined', 'Action \'' + name + '\' requires a \'filterParamsToProps\' property.');
            (0, _invariant2.default)(typeof filterParamsToProps === 'function', 'Action \'' + name + '\' expects \'filterParamsToProps\' to be a function.');

            if (typeof initServerAction !== 'undefined') {
                (0, _invariant2.default)(typeof initServerAction === 'function', 'Action \'' + name + '\' expects \'initServerAction\' to be a function.');
            }

            if (typeof initClientAction !== 'undefined') {
                (0, _invariant2.default)(typeof initClientAction === 'function', 'Action \'' + name + '\' expects \'initClientAction\' to be a function.');
            }

            if (typeof hoc !== 'undefined') {
                (0, _invariant2.default)(typeof hoc === 'function', 'Action \'' + name + '\' expects \'hoc\' to be a function.');
            }
        });
    }

    return function (Component) {
        var hocDispatcherActions = actions.slice();
        var isComponentNull = Component === null;
        var ComposedComponent = null;

        var actionHOC = function actionHOC(props) {
            return isComponentNull ? null : _react2.default.createElement(ComposedComponent, props);
        };

        actionHOC.appendActionDispatcher = function appendActionDispatcher(ActionDispatcherComponent) {
            var hocBlacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (typeof ActionDispatcherComponent === 'undefined' || ActionDispatcherComponent === null || typeof ActionDispatcherComponent.getDispatcherActions !== 'function') {
                // Ignore non dispatcher components
                return;
            }

            Array.prototype.unshift.apply(hocDispatcherActions, ActionDispatcherComponent.getDispatcherActions());
            hoistSafeStatics(actionHOC, ActionDispatcherComponent, hocBlacklist);
        };

        // Compose the actions (components)
        ComposedComponent = actions.reduceRight(function (child, _ref2) {
            var hoc = _ref2.hoc;

            if (typeof hoc !== 'function') {
                return child;
            }

            var wrappedComponent = hoc(child, actionHOC);
            var composedHOC = child === null || wrappedComponent === child ? wrappedComponent : hoistSafeStatics(wrappedComponent, child);

            if (child !== null) {
                composedHOC.WrappedComponent = child;

                if (typeof child.getDispatcherActions === 'function') {
                    Array.prototype.unshift.apply(hocDispatcherActions, child.getDispatcherActions());
                }
            }

            return composedHOC;
        }, Component);

        if (actions.length === 1 && !isComponentNull && typeof Component.getDispatcherActions === 'function') {
            // reduceRight() is not invoked when there is only a single action
            Array.prototype.unshift.apply(hocDispatcherActions, Component.getDispatcherActions());
        }

        if (__DEV__) {
            if (!isComponentNull) {
                actions.forEach(function (_ref3) {
                    var name = _ref3.name,
                        staticMethod = _ref3.staticMethod,
                        staticMethodName = _ref3.staticMethodName;

                    if (typeof staticMethod !== 'function') {
                        (0, _invariant2.default)(typeof ComposedComponent[staticMethodName] === 'function', 'Component \'' + (0, _reactDisplayName2.default)(Component) + '\' is using action \'' + name + '\' but missing the required static method \'' + staticMethodName + '\'.');
                    } else {
                        (0, _warning2.default)(typeof ComposedComponent[staticMethodName] !== 'function', 'Component \'' + (0, _reactDisplayName2.default)(Component) + '\' defines the static method \'' + staticMethodName + '\' for action \'' + name + '\', but it will never be invoked as the action has a static method assigned.');
                    }
                });
            }
        }

        actionHOC.displayName = 'withActions(' + (isComponentNull ? 'null' : (0, _reactDisplayName2.default)(ComposedComponent)) + ')';

        if (!isComponentNull) {
            actionHOC = hoistSafeStatics(actionHOC, ComposedComponent);
            actionHOC.WrappedComponent = ComposedComponent;
        }

        actionHOC.getDispatcherActions = function getDispatcherActions() {
            var permittedActionNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
                return true;
            };

            permittedActionNames = permittedActionNames || [];
            return hocDispatcherActions.filter(function (action) {
                return (permittedActionNames.length === 0 ? true : permittedActionNames.indexOf(action.name) !== -1) && filter(action);
            });
        };

        actionHOC.getDispatchParamToProps = function getDispatchParamToProps() {
            return paramsToProps;
        };

        return actionHOC;
    };
}